module.exports = __webpack_public_path__ + "img/relvado_01.e39dfc6a.jpg";